module.exports = __webpack_public_path__ + "img/finish-matte-black.29114cfe.jpg";